module.exports = __webpack_public_path__ + "img/icon-dsgvo.7ea7de62.svg";